import axios from "axios";

const api = axios.create({
  baseURL: "https://dashboard.almekyal.com/api",
});

export default api;
